import React, { createContext, useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Habitaciones from './views/Habitaciones';
import Entorno from './views/Entorno';
import Contacto from './views/Contacto';

import './App.scss';
import Footer from './components/Footer/Footer';
import Actividades from './views/Actividades';
import Conocenos from './views/Conocenos';

import AxiosService from './services/AxiosService';
import { DatosAppContext, ModeloDatosApp } from './context/DatosAppContext';

function App() {
  
  const [datosApp, setDatosApp] = useState(ModeloDatosApp);

  useEffect(() => {
    
    const url = "/login";
    const payloadLogin = {'email':'admin@alberguegriegos.com','password':'%1A2B3C4D5E6F7G8_'};
    const config = {'headers': {
        'Accept':'application/json', 
        'Content-Type': 'application/json'
    }};

    AxiosService.post(
        url, 
        payloadLogin,
        config
    )
    .then((response) => {
        
        if (response.data && response.data.accessToken) {
          console.log('token: ' + response.data.accessToken)
          setDatosApp({
              tokenApi: response.data.accessToken
            });
        } else {
          console.log("No hay datos devueltos")
        }

    })
    .catch((error) => {
        console.log(error.message)
    })
    .finally(() => {
        console.log("Login realizado correctamente")
    });
    
  }, []);  

  return (
    <>
      <DatosAppContext.Provider value={datosApp}>
        <Header />
        <Habitaciones />
        <Entorno />
        <Actividades />
        <Conocenos />
        <Contacto />
        <Footer />
      </DatosAppContext.Provider>
    </>
  );
}

export default App;
